/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_Ad_JobInputs */

const en_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit AD Job`)
};

const fr_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumettre une offre d'emploi`)
};

const de_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenanzeige einreichen`)
};

const it_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia un annuncio di lavoro`)
};

const ru_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить объявление о вакансии`)
};

const es_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar anuncio de empleo`)
};

const zh_cn2_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交广告职位`)
};

const ja_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告掲載求人`)
};

const hi_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नौकरी के लिए विज्ञापन जमा करें`)
};

const pt_pt2_submit_ad_job = /** @type {(inputs: Submit_Ad_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar anúncio de emprego`)
};

/**
* | output |
* | --- |
* | "Submit AD Job" |
*
* @param {Submit_Ad_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_ad_job = /** @type {((inputs?: Submit_Ad_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_Ad_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_submit_ad_job(inputs)
	if (locale === "de") return de_submit_ad_job(inputs)
	if (locale === "it") return it_submit_ad_job(inputs)
	if (locale === "ru") return ru_submit_ad_job(inputs)
	if (locale === "es") return es_submit_ad_job(inputs)
	if (locale === "zh-CN") return zh_cn2_submit_ad_job(inputs)
	if (locale === "ja") return ja_submit_ad_job(inputs)
	if (locale === "hi") return hi_submit_ad_job(inputs)
	if (locale === "pt-PT") return pt_pt2_submit_ad_job(inputs)
	return en_submit_ad_job(inputs)
});